import React, {useContext, useEffect, Fragment, useState} from "react";
import { observer } from "mobx-react";
import { RootStoreContext } from "../../core/store/rootStore";
import { Table, Button } from "reactstrap";
import UserModal from "./user.modal";
import TokenModal from "./token.modal";
import LoadingOverlay from 'react-loading-overlay';
import confirm from "reactstrap-confirm";
import {toast} from "react-toastify";

const UserAdministration = () => {
  const rootStore = useContext(RootStoreContext);
  const { loadUsers, userList, removeUser } = rootStore.userStore;
  const { openModal } = rootStore.modalStore;

  let [loading, setLoading] = useState(false);

  useEffect(() => {
    wrapLoadUsers();
  }, [loadUsers]);

  function openUserModal() {
    openModal(<UserModal />, null, () => {
      wrapLoadUsers();
    }, "xl");
  }

  function editUserModal(user) {
    openModal(<UserModal />, user, () => {
      wrapLoadUsers();
    }, "xl");
  }

  function getToken(user) {
    openModal(<TokenModal />, user);
  }

  async function remove(user) {
    let result = await confirm({
      title: (
          <>
            Supprimer un utilisateur
          </>
      ),
      message: "Cliquez sur \"supprimer\" pour supprimer l'utilisateur.",
      confirmText: "Supprimer",
      confirmColor: "primary",
      cancelColor: "link text-danger",
      cancelText: "Annuler"
    });

    if (result) {
      setLoading(true);
      removeUser(user).then(() => {
        setLoading(false);

        toast.success("L'utilisateur a été supprimé avec succès");

        loadUsers();
      });
    }
  }

  function wrapLoadUsers() {
    setLoading(true);
    loadUsers().then(() => {
      setLoading(false);
    });
  }

  return (
    <Fragment>
      <div><b>Gestion des utilisateurs</b></div>
      <div className="row">
        <div className="col-md-12 text-right" style={{ padding: 10 }}>
          <Button className="btn-primary" onClick={openUserModal}>Créer un nouvel utilisateur</Button>
        </div>
      </div>
      <div>
        <LoadingOverlay
            active={loading}
            spinner>
          <Table striped>
            <thead>
            <tr key={1}>
              <th>Prénom</th>
              <th>Nom de famille</th>
              <th>Nom d'utilisateur</th>
              <th>Société</th>
              <th>&nbsp;</th>
            </tr>
            </thead>
            <tbody>
            {userList.map((user, index) => (
                <tr key={index}>
                  <td>{user.name}</td>
                  <td>{user.surname}</td>
                  <td>{user.username}</td>
                  <td>{user.companyName}</td>
                  <td className="text-right">
                    <Button className="btn-primary" onClick={(e) => editUserModal(user, e)}>Edition</Button>
                    <Button className="btn-primary ml-2" onClick={(e) => getToken(user, e)}>Obtenir le Token</Button>
                    <Button className="btn-danger ml-2" onClick={(e) => remove(user, e)}>Supprimer</Button>
                  </td>
                </tr>
            ))}
            </tbody>
          </Table>
        </LoadingOverlay>
      </div>
    </Fragment>
  );
};

export default observer(UserAdministration);
